import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import React, { useState } from 'react'
// import './style/drag.less'
import { IconFileList } from '@arco-iconbox/react-aidb'
import { InputTag } from '@arco-design/web-react'
function MyComponent() {
  const [categories, setCategories] = useState([
    { id: 'category1', name: 'Category 1' },
    { id: 'category2', name: 'Category 2' },
    { id: 'category3', name: 'Category 3' },
  ])

  const handleDragEnd = (result) => {
    if (!result.destination) return

    const reorderedCategories = Array.from(categories)
    const [movedCategory] = reorderedCategories.splice(result.source.index, 1)
    reorderedCategories.splice(result.destination.index, 0, movedCategory)

    setCategories(reorderedCategories)
    console.log(reorderedCategories, 'reorderedCategories')
  }

  const deleteHandle = (name) => {
    console.log(name)
  }

  const pressEnterHandle = () => {
    console.log('ppp')
  }
  const options = ['arcoblue', 'orange', 'lime']

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="categories">
        {(provided) => (
          <div
            className="dragBox"
            ref={provided.innerRef}
            {...provided.droppableProps}>
            {categories.map((category, index) => (
              <Draggable
                key={category.id}
                draggableId={category.id}
                index={index}>
                {(provided) => (
                  <div
                    className="dragItem"
                    ref={provided.innerRef}
                    {...provided.draggableProps}>
                    <div className="category-item">
                      <div
                        className="drag-handle"
                        {...provided.dragHandleProps}>
                        <IconFileList />
                      </div>
                      <input type="text" value={category.name} />
                      <div className="category-name">{category.name}</div>
                      <button
                        onClick={() => deleteHandle(category.name)}
                        className="delete-button">
                        删除
                      </button>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <InputTag
        placeholder="Input and press Enter"
        style={{ width: 350 }}
        labelInValue
        defaultValue={options}
        onPressEnter={pressEnterHandle}
      />
    </DragDropContext>
  )
}

export default MyComponent
